var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NewsListPage',{attrs:{"title":"行业新闻","category-name":"行业新闻","category-path":"industry","root-class":"industry-news","page-size":6}})
}
var staticRenderFns = []

export { render, staticRenderFns }